import {
  BnbIcon,
  EthIcon,
  PolygonIcon,
  EdexaIcon,
} from "./imgIcon";

const assets = [
  {
    label: "EDX",
    name: "edx",
    balance: 8757.0,
    currency: "EDX",
    networks: ["ethereum", "BNB", "polygon"],
    icon: EdexaIcon(),
    isSelected: true,
  },
];


const net_works = [

  {
    label: "Ethereum",
    name: "ethereum",
    provider: "https://ethereum-rpc.publicnode.com",
    currency: "ETH",
    icon: EthIcon(),
    isSelectedAsFrom: true,
    isSelectedAsTo: false,
    chainId: "0x1",
    erc20: "0xC114678C6e4654d041B2006C90f08478b444c4E2",
    CCpool: "0xdDA61D8611091487eB5d14Ca2f6F24cCE877317e",
    WID: 2147483708,
    gateway: "0x7280E3b8c686c68207aCb1A4D656b2FC8079c033"
  },
  {
    label: "Polygon",
    name: "polygon",
    provider: "https://polygon-bor-rpc.publicnode.com",
    currency: "POL",
    icon: PolygonIcon(),
    isSelectedAsFrom: false,
    isSelectedAsTo: false,
    chainId: "0x89",
    erc20: "0xC114678C6e4654d041B2006C90f08478b444c4E2",
    CCpool: "0x7A59786E4C9d6E858bd21f1c050A5184ac2c39b0",
    WID: 2147484614,
    gateway: "0x7280E3b8c686c68207aCb1A4D656b2FC8079c033"
  },
  {
    label: "BSC",
    name: "bsc",
    provider: "https://bsc-rpc.publicnode.com",
    currency: "BNB",
    icon: BnbIcon(),
    isSelectedAsFrom: false,
    isSelectedAsTo: true,
    chainId: "0x38",
    erc20: "0xC114678C6e4654d041B2006C90f08478b444c4E2",
    CCpool: "0xa9Be0cE3393Cda9dfa8A8dfB7CB0e29cF9608DA4",
    WID: 2147484362,
    gateway: "0x7280E3b8c686c68207aCb1A4D656b2FC8079c033"
  },
  {
    label: "edeXa",
    name: "edexa",
    provider: "https://rpc.edexa.network",
    currency: "EDX",
    icon: EdexaIcon(),
    isSelectedAsFrom: false,
    isSelectedAsTo: false,
    chainId: "0x1530",
    // erc20: "",
    CCpool: "0x635E175CBaC135Ea029E8333b8BBf2c07e645F13", // replace with edexa contract address
    WID: 1073741850,
    gateway: "0x7280E3b8c686c68207aCb1A4D656b2FC8079c033"
  }
];

export { net_works, assets };
